import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { AddLiberatoria } from "./add"
import { LiberatorieFromCodex } from "./liberatorieFromCodex"
import { LiberatorieToCodex } from "./liberatorieToCodex"
import { GetWaivertoExcel, resetWaiverRequest } from "./liberatorieToCodex/dataService/slice"


export function Liberatorie() {
    const dispatch = useAppDispatch()
    const waiverToState = useAppSelector(state => state.waiverToCodex)

    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showPopupToAdd, setShowPopupToAdd] = useState<boolean>(false);
    const [showPopupFromAdd, setShowPopupFromAdd] = useState<boolean>(false);

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CONTROLLO}
            breadcrumbItems={['Gestione Controllo', 'Liberatorie']}
            noPaddingLat
            headerLabel="Liberatorie"
            headerChildren={
                <div className="flex items-center h-full w-full justify-end gap-2">
                    {
                        selectedTab === 0 ?
                            <ButtonComponent
                                size="sm"
                                iconPosition="off"
                                variant="solid"
                                color="orange"
                                label="Aggiungi Richiesta"
                                onClick={() => setShowPopupToAdd(true)}
                            />
                            :
                            selectedTab === 1 &&
                            <ButtonComponent
                                size={"sm"}
                                iconPosition={"off"}
                                variant={"solid"}
                                label="Aggiungi Richiesta"
                                color={"orange"}
                                onClick={() => setShowPopupFromAdd(true)}
                            />
                    }
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Scarica Excel"
                        color={"green"}
                        onClick={() => dispatch(GetWaivertoExcel(waiverToState.getAllWaiverToFilters))}
                    />
                </div>
            }
        >
            <>
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Richieste a Codex</div>
                    <div>Richieste da Codex</div>
                </CustomHorizontalTab>
                <div className="fieldset bg-brandPrimary-200">
                    {
                        selectedTab === 0 &&
                        <LiberatorieToCodex
                            showPopupToAdd={showPopupToAdd}
                            setShowPopupToAdd={setShowPopupToAdd}
                        />
                    }
                    {
                        selectedTab === 1 &&
                        <LiberatorieFromCodex
                            showPopupFromAdd={showPopupFromAdd}
                            setShowPopupFromAdd={setShowPopupFromAdd}
                        />
                    }
                </div>
                {
                    showPopupToAdd && (
                        <PopupForm title="Crea liberatoria richiesta a Codex" close={() => setShowPopupToAdd(false)}>
                            <AddLiberatoria close={() => { setShowPopupToAdd(false); dispatch(resetWaiverRequest()) }} type="to" />
                        </PopupForm>
                    )
                }
                {
                    showPopupFromAdd && (
                        <PopupForm title="Crea liberatoria richiesta da Codex" close={() => setShowPopupFromAdd(false)}>
                            <AddLiberatoria close={() => { setShowPopupFromAdd(false); dispatch(resetWaiverRequest()) }} type="from" />
                        </PopupForm>
                    )
                }
            </>

        </Layout>
    )
}